import { Bike, Wrench, BatteryCharging, Shield, Zap, Package, Tag, Settings } from 'lucide-react'

const MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  'bike': Bike,
  'wrench': Wrench,
  'battery-charging': BatteryCharging,
  'shield': Shield,
  'zap': Zap,
  'package': Package,
  'tag': Tag,
  'settings': Settings,
}

export function CategoryIconPreview({ name, className = 'w-5 h-5' }: { name: string; className?: string }) {
  const Icon = MAP[name] ?? Package
  return <Icon className={className} />
}
